<template>
  <div>
    <header class="lmy-header lmy-header-w">
      <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
      推广二维码
    </header>



    <div  v-if="!userQr" class="mg-top-load">
      <div class="infinite-loading-containers">
        <i class="loading-defaults"></i>
      </div>
    </div>

    <div v-show="userQr">
      <div class="my-user-qr-box">
          <div class="lmy-qr">
             <img class="lmy-my-qr" :src="'data:image/jpeg;base64,'+userQr"/>
          </div>
          <div class="lmy-qr-info">
              <ul>
                <li>
                  <span></span>
                  通过该二维码扫描注册新用户会自动绑定为您的【下级帐号】
                </li>
                <li>
                  <span></span>
                  当【下级帐号】产生预定时您会同步获得佣金收益
                </li>
                <li>
                  <span></span>
                  当您的【下级账号】发展【下下级】并产生预订时，您同样会获得佣金收益
                </li>
                <li>
                  <span></span>
                  收益明细详见：后台---佣金提现
                </li>
              </ul>
          </div>
        
      </div>


    </div>
  </div>
</template>
<script>
  export default {
    name: 'withdraw',
    data() {
      return {
        userQr: '',
        mask:false
      }
    },
    methods: {
      initData() {
        var that = this;
        // var params = {
        //   width: '300',
        //   height: '300'
        // }
        that.getRequest({
          url: this.Api.getMyUserQR,
          // params: params
        }).then(res => {
          if (res) {

            that.userQr = res;
          } else {
            that.error({title: '提示', content: '暂无二维码'});
          }
        });
      }

    },
    mounted() {
      this.initData();
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/usr/qr/myQr.vue